var jade = require("/home/circleci/rentapplication-frontend/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<div class=\"my-payments\"><div class=\"wrapper-main\"><div class=\"pay-active2-success active\"><div class=\"image-success\"></div><h2>Success!</h2><p>You have successfully activated My Payments</p><div class=\"text-container\"><img" + (jade.attr("src", require('./building.png'), true, true)) + "><p>Within the next few days you will receive test deposits in your bank account to complete the setup of your My Payments account.</p></div><a ui-sref=\"root.dashboard.forms\" class=\"go-to-dashboard\">Go to Dashboard</a></div></div></div>");;return buf.join("");
}


//////////////////
// WEBPACK FOOTER
// ./components/dashboard/payments/signup/success/success.jade
// module id = 764
// module chunks = 0